// Reusable localStorage with expiration utilities
export const localStorageWithExpiry = {
  setItem: (key: string, value: any, expirationHours: number = 4) => {
    const dataWithTimestamp = {
      timestamp: Date.now(),
      expirationHours,
      data: value
    };
    
    try {
      localStorage.setItem(key, JSON.stringify(dataWithTimestamp));
      return true;
    } catch (e: any) {
      if (e.name === 'QuotaExceededError') {
        // Clear expired items and try again
        localStorageWithExpiry.clearExpired();
        
        try {
          localStorage.setItem(key, JSON.stringify(dataWithTimestamp));
          return true;
        } catch (e2) {
          console.error('Still unable to save after clearing expired items:', e2);
          return false;
        }
      }
      return false;
    }
  },
  
  getItem: (key: string) => {
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    
    try {
      const parsed = JSON.parse(stored);
      
      // Check if it has our timestamp format
      if (parsed.timestamp && 'data' in parsed) {
        const now = Date.now();
        const expirationMs = (parsed.expirationHours || 4) * 60 * 60 * 1000;
        
        if ((now - parsed.timestamp) > expirationMs) {
          localStorage.removeItem(key);
          return null;
        }
        
        return parsed.data;
      }
      
      // Return as-is if old format
      return parsed;
    } catch (e) {
      console.error('Error parsing stored data:', e);
      return null;
    }
  },
  
  clearExpired: (keyPrefix?: string) => {
    const now = Date.now();
    const keysToRemove: string[] = [];
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      
      // If prefix provided, only check keys with that prefix
      if (keyPrefix && !key.startsWith(keyPrefix)) continue;
      
      try {
        const stored = localStorage.getItem(key);
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed.timestamp) {
            const expirationMs = (parsed.expirationHours || 4) * 60 * 60 * 1000;
            if ((now - parsed.timestamp) > expirationMs) {
              keysToRemove.push(key);
            }
          }
        }
      } catch (e) {
        // Skip items that can't be parsed
      }
    }
    
    keysToRemove.forEach(key => {
      console.log(`Removing expired item: ${key}`);
      localStorage.removeItem(key);
    });
    
    return keysToRemove.length;
  },
  
  clearByPrefix: (prefix: string, exceptKey?: string) => {
    const keysToRemove: string[] = [];
    
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix) && key !== exceptKey) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => localStorage.removeItem(key));
    return keysToRemove.length;
  }
};